<template>
  <div ref="alertModalRef" class="modal-overlay hidden" :class="{ 'dark-theme': isDark }" @click.self="closeModal">
        <div class="modal-container">
          <div class="modal-icon-wrapper">
            <template v-if="modelType == 'success'">
                <div class="modal-icon success-icon">
                  <span>✓</span>
                </div>
            </template>
            <template v-if="modelType == 'error'">
                <div class="modal-icon error-icon">
                    <svg class="error-icon-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                        <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
                    </svg>
                </div>
            </template>
          </div>
          <div class="modal-body">
            <h5 class="modal-title">{{ $t(modalTitle) }}</h5>
            <p class="modal-text">{{ $t(modalText) }}</p>
          </div>
          <button class="btn btn-confirm" @click="closeModal">{{ $t(modalButtonText) }}</button>
        </div>
    </div>
</template>

<script setup>
 import { defineEmits, defineProps, ref } from "vue";
 const props = defineProps({
  modalTitle: String,
  modalText: String,
  modalButtonText: String,
  modalIcon: String,
  modelType: String,//success/error
  id: String,
  isDark: Boolean,
});
const alertModalRef = ref(null)


const showModal = () => {
  alertModalRef.value?.classList.remove('hidden')
}
const closeModal = () => {
  alertModalRef.value?.classList.add('hidden')
};

defineExpose({
  showModal,
  closeModal
})
</script>

<style>
/* Dark Mode - Alert Modal */
.dark-theme.modal-overlay .modal-container,
.dark-theme .modal-container {
  background-color: #1E1E1E;
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-title,
.dark-theme .modal-title {
  color: #ffffff;
}
.dark-theme.modal-overlay .modal-text,
.dark-theme .modal-text {
  color: #a0a0a0;
}
</style>
 